import { Installation } from 'src/Libs/installations/models/installation.model'
import React, { useState } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { InstallationsApiView } from 'src/Libs/installations/components/InstallationsApiView'
import { allInstallationsFetchProps, allInstallationsWithDecommissionsFetchProps } from 'src/Libs/installations/utils/installation-table-columns'
import { INSTALLATION_FILTER_PROPERTIES_ALL } from 'src/Configuration'
import { BlankViewImageVariants, BlankView, BlankViewImageSizes } from 'src/Components/blank-view'
import { UrlParams } from '@e3dc-react/shell/Types'
import { NewInstallationButton } from '../new-installation'

interface CompletedInstallationsProps {
  onSelect: (installation?: Installation) => void
  showStatusColumn?: boolean
  urlParams?: UrlParams
  showFullActionsMenu?: boolean
}

/**
 * Component to display the completed installations in the overview
 */
const CompletedInstallations: React.FC<CompletedInstallationsProps> = ({ onSelect, showStatusColumn, urlParams, showFullActionsMenu }) => {
  const { t } = useCustomTranslation()
  const [filterQuery, setFilterQuery] = useState('')

  return (
    <InstallationsApiView
      keyValue={3}
      fetchProps={showStatusColumn ? allInstallationsWithDecommissionsFetchProps : allInstallationsFetchProps}
      dataQaPrefix={'installations-complete'}
      onSelect={onSelect}
      oneFilter={{
        properties: INSTALLATION_FILTER_PROPERTIES_ALL,
        label: t('common.search'),
        filterQuery,
        setFilterQuery,
        urlParams,
      }}
      showStatus={showStatusColumn}
      blankView={
        <BlankView
          imageVariant={BlankViewImageVariants.Neutral}
          imageSize={BlankViewImageSizes.Small}
          title={'companyDashboard.blank-view.require-installations-complete.title'}
          explanation={'companyDashboard.blank-view.require-installations-complete.explanation'}
        />
      }
      showFullActionsMenu={showFullActionsMenu}
      showOptionsMenu
      onSelectOnlyInList
      actionButton={<NewInstallationButton />}
    />
  )
}

export default CompletedInstallations
